<template>
  <collapse-group
    title="Comments"
    :init-collapse="task_comment_list.length === 0"
    class="task-page-comments">
    <div
      v-for="taskComment in task_comment_list"
      :key="taskComment.$key"
      class="el-card list-item p-2 mb-2">

      <p class="mb-1">{{taskComment.message}}</p>

      <span style="font-size: 8pt; color: gray">
        {{taskComment.createdAt|fromNow}} by
        <user-mini-avatar :user-id="taskComment.authorUserId" size="small" />
      </span>

      <font-awesome-icon
        v-if="taskComment.authorUserId === $models.user.defaultUserId"
        icon="trash"
        class="inline-icon"
        style="float: right"
        @click="onDeleteComment(taskComment.$id)" />
    </div>

    <div style="display: flex">
      <el-input
        v-model="message"
        @keydown.native.enter="onClickAddComment"
        class="p-0 mr-2" ref="chat_input" ></el-input>
      <el-button @click="onClickAddComment" class="px-3">
        <font-awesome-icon :icon="['far', 'comment']" />
      </el-button>
    </div>
  </collapse-group>
</template>

<script>
export default {
  props: {
    task: { required: true },
    memberId: { required: true },
  },
  data: () => ({
    message: ''
  }),
  computed: {
    taskComment() {
      return this.$models.taskComment.with({
        goalId: this.task.goalId,
        uid:    this.memberId,
        taskId: this.task.$id
      })
    },
    task_comment_list() {
      if ( !this.taskComment ) {
        return []
      }
      return this.taskComment.subscribeList().itemsAsArray() // TODO: sort
    },
  },
  methods: {
    onDeleteComment( taskCommentId ) {
      this.taskComment.remove( taskCommentId )
    },

    onClickAddComment() {
      let userId = this.$models.user.defaultUserId;
      if ( this.message === '' ) {
        return
      }
      this.taskComment.add({
        authorUserId: userId,
        message: this.message,
      }).then(() => {
        this.message = '';
      })
    },
  }
}
</script>
